module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAbUlEQVQ4EaXBsQ0DQQzAMGn/oR2VDxeBgSPlkTySR7JMODBElgkHhsgy4cAQWSYcGCJHEz4MkaMJH4bIMuHAEFkmHBgiy4QDQ2SZcGCILBM+DH/IMuHD8IcsEw4MkWXCgSGyTDgwRJYJB4bIox86oUAVj7uH4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_02.png
// module id = 235
// module chunks = 0